module.exports = __webpack_public_path__ + "img/26.95c85f5f.png";